/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { AuthControllerRevokeTokenMutationResponse, AuthControllerRevokeToken400, AuthControllerRevokeToken401, AuthControllerRevokeToken404, AuthControllerRevokeToken409, AuthControllerRevokeToken500 } from "../types/AuthControllerRevokeToken.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getAuthControllerRevokeTokenUrl() {
  const res = { method: 'POST', url: `/auth/revoke` as const }
  return res
}

/**
 * @description Revokes the refresh token sent as HttpOnly cookie. Used for logout on the current device. Does not require an access token — the refresh token cookie is the credential.
 * @summary Revoke current refresh token
 * {@link /auth/revoke}
 */
export async function authControllerRevokeToken(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuthControllerRevokeTokenMutationResponse, ResponseErrorConfig<AuthControllerRevokeToken400 | AuthControllerRevokeToken401 | AuthControllerRevokeToken404 | AuthControllerRevokeToken409 | AuthControllerRevokeToken500>, unknown>({ method : "POST", url : getAuthControllerRevokeTokenUrl().url.toString(), ... requestConfig })
  return res.data
}